import { render, staticRenderFns } from "./vendorContacts.vue?vue&type=template&id=269559aa&scoped=true"
import script from "./vendorContacts.vue?vue&type=script&lang=js"
export * from "./vendorContacts.vue?vue&type=script&lang=js"
import style0 from "./vendorContacts.vue?vue&type=style&index=0&id=269559aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269559aa",
  null
  
)

export default component.exports